import React from 'react';
import './CollapsibleSection.scss';

const ICON_EXPANDED_URL = '../images/shared/AppointmentScheduler/icon-expanded.svg';
const ICON_COLLAPSED_URL = '../images/shared/AppointmentScheduler/icon-collapsed.svg';

// probably need to import path

export default class CollapsibleSection extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let expandedClass = this.props.isExpanded ? 'expanded' : '';
        let iconUrl = this.props.isExpanded ? ICON_EXPANDED_URL : ICON_COLLAPSED_URL;

        return (
            <div className={`collapsible-section ${expandedClass}`}>
                {this.props.isExpanded && 
                    <div className="collapsible-content">{this.props.children}</div>}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./Src/Appointment/AppointmentScheduler/AppointmentForm/CollapsibleSection/CollapsibleSection.jsx